import config from "../config";
const { intercomMessengerId } = config;
export const IntercomTrack = async (currentUser, pharmacy, company, page) => {
  if (typeof window !== "undefined" && typeof window.Intercom === "function") {
    // It's better to call "update" if Intercom is already booted
    window.Intercom("update", {
      app_id: intercomMessengerId,
      email: currentUser?.emailAddress,
      user_id: currentUser?.emailAddress, // Should be a unique user ID
      name: currentUser?.fullName,
      pharmacy: pharmacy?.teamPharmacyName,
      company: company?.companyName,
    });

    // Track the event
    window.Intercom("trackEvent", page, {
      title: page,
      actionType: page,
      pharmacy: pharmacy?.teamPharmacyName,
      company: company?.companyName,
      user: currentUser?.emailAddress,
    });
  } else {
    console.warn("Intercom is not available or not loaded yet.");
  }
};
